module.exports = __webpack_public_path__ + "img/h7.ad939b05.png";